import React, { useEffect, useState } from "react";
import { fetchHistoricoSaldo } from "../../../integration/historico_saldo/fetchHistoricoSaldo";
import { formatToBRL } from "brazilian-values";
import { BiRefresh } from "react-icons/bi";

const SaldoTabela = () => {
  const [historicoSaldo, setHistoricoSaldo] = useState([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [carregando, setCarregando] = useState(false);
  const itensPorPagina = 10;

  const funcHistoricoSaldo = async () => {
    setCarregando(true);
    try {
      const resposta = await fetchHistoricoSaldo({
        paginaAtual,
        itensPorPagina
      });

      const { dados, total } = resposta;

      setHistoricoSaldo(dados || []);
      setTotalRegistros(total || 0);

      const paginasCalculadas = Math.ceil((total || 0) / itensPorPagina);
      setTotalPaginas(paginasCalculadas);
    } catch (erro) {
      console.error("Erro ao buscar histórico de saldo:", erro);
      setHistoricoSaldo([]);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    funcHistoricoSaldo();
  }, [paginaAtual]);

  const formatToDateTime = (dataStr) => {
    if (!dataStr) return "-";
    const data = new Date(dataStr);
    return data.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  };

  return (
    <div className="w-full max-w-7xl mx-auto p-6 bg-[#fcfcfd] rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-3xl font-light text-[#0c0c0c]">Saldo</h2>
        <span className="text-gray-500 text-sm">
          Total: <strong>{totalRegistros}</strong> registros
        </span>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <button
          onClick={() => funcHistoricoSaldo()}
          className="inline-flex items-center gap-2 px-5 py-2 bg-[#f5f4f1] text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition"
        >
          <BiRefresh className="w-5 h-5" />
          Atualizar Histórico
        </button>
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-[#f5f4f1] text-gray-700 font-semibold">
            <tr>
              {["Data", "Descrição", "Entradas", "Saídas"].map((title) => (
                <th key={title} className="px-4 py-3 text-left">
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {carregando ? (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  Carregando...
                </td>
              </tr>
            ) : historicoSaldo.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              historicoSaldo.map((item, index) => {
                const entrada = item.credit || 0;
                const saida = item.debit || 0;

                return (
                  <tr key={index} className="hover:bg-gray-50 transition">
                    <td className="px-4 py-3">
                      {formatToDateTime(item.movementDate)}
                    </td>
                    <td className="px-4 py-3">{item.description}</td>
                    <td className="px-4 py-3">{formatToBRL(entrada / 100)}</td>
                    <td className="px-4 py-3">{formatToBRL(saida / 100)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-700">
        <div>
          Página <strong className="text-black">{paginaAtual}</strong> de{" "}
          <strong className="text-black">{totalPaginas}</strong>
        </div>

        {/* Botões Anterior / Próxima */}
        <div className="flex gap-2">
          <button
            onClick={() => setPaginaAtual((prev) => Math.max(prev - 1, 1))}
            disabled={paginaAtual === 1}
            className={`px-4 py-2 rounded-md transition ${
              paginaAtual === 1
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            Anterior
          </button>
          <button
            onClick={() =>
              setPaginaAtual((prev) => Math.min(prev + 1, totalPaginas))
            }
            disabled={paginaAtual === totalPaginas}
            className={`px-4 py-2 rounded-md transition ${
              paginaAtual === totalPaginas
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            Próxima
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaldoTabela;
